/**
 * Fill in the Blanks element
 */

import type { ElementDefinition } from '@ai-content-hub/content-kit';
import {
    fitbElementSchema,
    type FITBElementData,
    type FITBBlank,
    type FITBBlankMode,
    type FITBConfig,
    type FITBElementPlayerConfig,
    type FITBAnswer,
    defaultFITBConfig,
    defaultFITBElementData,
    normalizeFITBData,
    syncBlanksWithPassage,
    countBlanksInTiptap,
    blankMarkerLengthsInPassageOrder,
    getFITBBlankMode,
    isCaseSensitive,
    shouldShuffleOptions,
    blankIdForIndex,
    createDefaultBlank,
    FITB_BLANK_MARKER_REGEX,
} from './schema';
import { FITBEdit } from './FITBEdit';
import { FITBPlayer } from './FITBPlayer';
import { FITBPlayerDrag } from './FITBPlayerDrag';
import { FITBPlayerDropdown } from './FITBPlayerDropdown';
import { FITBPlayerType } from './FITBPlayerType';
import { fitbGrader } from './grader';
import { renderPassageWithBlanks } from './PassageRenderer';

export {
    fitbElementSchema,
    type FITBElementData,
    type FITBBlank,
    type FITBBlankMode,
    type FITBConfig,
    type FITBElementPlayerConfig,
    type FITBAnswer,
    defaultFITBConfig,
    defaultFITBElementData,
    normalizeFITBData,
    syncBlanksWithPassage,
    countBlanksInTiptap,
    blankMarkerLengthsInPassageOrder,
    getFITBBlankMode,
    isCaseSensitive,
    shouldShuffleOptions,
    blankIdForIndex,
    createDefaultBlank,
    FITB_BLANK_MARKER_REGEX,
};
export { FITBEdit };
export type { FITBEditProps } from './FITBEdit';
export { FITBPlayer };
export { FITBPlayerDrag };
export { FITBPlayerDropdown };
export { FITBPlayerType };
export {
    fitbGrader,
    FITB_VALIDATE_ACCEPTED_ANSWER_REQUIRED,
    FITB_VALIDATE_PASSAGE_REQUIRED,
} from './grader';
export { renderPassageWithBlanks };
export type { PassageRenderContext } from './PassageRenderer';

export const fitbElement: ElementDefinition<FITBElementData, FITBAnswer> = {
    schema: fitbElementSchema,
    EditComponent: FITBEdit as ElementDefinition<FITBElementData, FITBAnswer>['EditComponent'],
    PlayerComponent: FITBPlayer as ElementDefinition<FITBElementData, FITBAnswer>['PlayerComponent'],
    grader: fitbGrader,
    validator: {
        validate: fitbGrader.validate!,
    },
};
